import { render, staticRenderFns } from "./SidebarEditQuestion.vue?vue&type=template&id=9551195c&scoped=true"
import script from "./SidebarEditQuestion.vue?vue&type=script&lang=js"
export * from "./SidebarEditQuestion.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditQuestion.vue?vue&type=style&index=0&id=9551195c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9551195c",
  null
  
)

export default component.exports